import { axiosEduServer } from "../utils/configAxios";

export const crearRegistroV2 = (data) => {
  return axiosEduServer.post('/registro/v2', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarRegistroV2 = (id, data) => {
  return axiosEduServer.put(`/registro/v2/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarRegistroV2 = (id) => {
  return axiosEduServer.delete(`/registro/v2/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneRegistroV2 = (id) => {
  return axiosEduServer.get(`/registro/v2/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistrosV2 = () => {
  return axiosEduServer.get('/registro/v2').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistrosV2ByIdEstudianteIdIdiomaEstado = (idEstudiante, idIdioma, estado) => {
  return axiosEduServer.get(`/registro/v2/idestudiante/${idEstudiante}/ididioma/${idIdioma}/estado/${estado}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllRegistrosV2ByIdDocenteIdIdiomaIdGrupoEstado = (idDocente, idIdioma, idGrupo, estado) => {
  return axiosEduServer.get(`/registro/v2/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/${estado}`).then(({ data }) => data).catch((err) => { throw err });
};

// Obtener todos los registros de un grupo (todos los estados: Progreso, Aprobado, Reprobado, Culminado)
export const getAllRegistrosV2ByIdDocenteIdIdiomaIdGrupo = async (idDocente, idIdioma, idGrupo) => {
  try {
    const [progreso, aprobado, reprobado, culminado] = await Promise.allSettled([
      axiosEduServer.get(`/registro/v2/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Progreso`),
      axiosEduServer.get(`/registro/v2/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Aprobado`),
      axiosEduServer.get(`/registro/v2/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Reprobado`),
      axiosEduServer.get(`/registro/v2/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/Culminado`)
    ]);

    const resultados = [];
    if (progreso.status === 'fulfilled') resultados.push(...(progreso.value.data || []));
    if (aprobado.status === 'fulfilled') resultados.push(...(aprobado.value.data || []));
    if (reprobado.status === 'fulfilled') resultados.push(...(reprobado.value.data || []));
    if (culminado.status === 'fulfilled') resultados.push(...(culminado.value.data || []));

    return resultados;
  } catch (err) {
    throw err;
  }
};

export const actualizarRegistroNotaV2 = (id, data) => {
  return axiosEduServer.put(`/registro/v2/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarRegistroCongeladoV2 = (id, data) => {
  return axiosEduServer.put(`/registro/v2/congelado/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

